export default {
  savedRecipes: {},
  searchTerm: '',
  recipes: {},
  view: 'search', // search or favourites (or recipe ?)
  filters: {
    ALC: false,
    ARM: false,
    BSM: false,
    CRP: false,
    CUL: false,
    GSM: false,
    LTW: false,
    WVR: false,
    BTN: false,
    FSH: false,
    MIN: false
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js